document.addEventListener('DOMContentLoaded', function () {
    const deferredMedia = document.querySelector('deferred-media');
    console.log("Loaded");
    if (deferredMedia) {
        console.log("Play Video");
        const videoTemplate = deferredMedia.querySelector('template');
        const videoElement = videoTemplate.content.querySelector('video');

        // Load the video by replacing the button with the video content
        deferredMedia.addEventListener('click', () => {
            if (!deferredMedia.classList.contains('media-loaded')) {
                deferredMedia.appendChild(videoTemplate.content);
                deferredMedia.classList.add('media-loaded');
                videoElement.play(); // Autoplay the video
            }
        });

        // Auto-trigger the video on page load
        setTimeout(() => {
            if (!deferredMedia.classList.contains('media-loaded')) {
                deferredMedia.appendChild(videoTemplate.content);
                deferredMedia.classList.add('media-loaded');
                videoElement.play();
            }
        }, 1000); // Adjust delay as needed
    }
});